export default __webpack_public_path__ + "static/rpacase1-dd4fb413bf8170979d0764c096afe849.jpg";